<template>
  <div class="teacher-gallery__filter">
    <label for="critique">
      <input
        type="checkbox"
        name="critique"
        id="critique"
        :checked="filter.critique"
        @change="updateFilterHandler"
      />
      Critique
    </label>
    <label for="viewing">
      <input
        type="checkbox"
        name="viewing"
        id="viewing"
        :checked="filter.viewing"
        @change="updateFilterHandler"
      />
      Viewing
    </label>

    <label for="showingDelete">
      <input
        type="checkbox"
        name="showingDelete"
        id="showingDelete"
        :checked="filter.showingDelete"
        @change="updateFilterHandler"
      />
      Delete mode
    </label>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'gallery-filter',

  methods: {
    ...mapActions('teacher', ['updateFilter']),
    updateFilterHandler(e) {
      const filter = e.target.id;
      const value = e.target.checked;

      this.updateFilter({ filter, value });
    },
  },
  computed: {
    ...mapState('teacher', {
      filter: state => state.filter,
    }),
  },
};
</script>

<style lang="scss" scoped>
.teacher-gallery__filter {
  padding: 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid color('grey');
  justify-content: center;
  background: color('background');

  label {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    cursor: pointer;

    input {
      margin-right: 0.5rem;
    }
  }
}
</style>
